import { Component, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ts-gdpr-notice-dialog',
    templateUrl: './gdpr-notice-dialog.component.html',
    styleUrls: ['./gdpr-notice-dialog.component.scss'],
    standalone: false
})
export class GdprNoticeDialogComponent {}

@NgModule({
  imports: [TranslateModule, MatDialogModule],
  declarations: [GdprNoticeDialogComponent],
})
export class GdprNoticeDialogModule {}
